export default "__VITE_ASSET__TjmQ2j7O__"